import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "page-suno"
};
const _hoisted_2 = {
  class: "left-bar"
};
const _hoisted_3 = {
  class: "bar-top"
};
const _hoisted_4 = {
  class: "params"
};
const _hoisted_5 = {
  class: "pure-music"
};
const _hoisted_6 = {
  class: "switch"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 0,
  class: "item-group"
};
const _hoisted_9 = {
  class: "label"
};
const _hoisted_10 = {
  class: "item",
  "element-loading-text": "正在生成歌词..."
};
const _hoisted_11 = {
  class: "item-group"
};
const _hoisted_12 = {
  class: "label"
};
const _hoisted_13 = {
  class: "item"
};
const _hoisted_14 = {
  class: "tag-select"
};
const _hoisted_15 = {
  class: "inner"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "item-group"
};
const _hoisted_18 = {
  class: "label"
};
const _hoisted_19 = {
  class: "item"
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  class: "label"
};
const _hoisted_22 = {
  class: "item"
};
const _hoisted_23 = {
  key: 2,
  class: "ref-song"
};
const _hoisted_24 = {
  class: "label"
};
const _hoisted_25 = {
  class: "item"
};
const _hoisted_26 = {
  class: "song"
};
const _hoisted_27 = {
  class: "title"
};
const _hoisted_28 = {
  class: "extend-secs"
};
const _hoisted_29 = {
  class: "submit-btn"
};
const _hoisted_30 = {
  class: "right-box h-dvh",
  "element-loading-background": "rgba(100,100,100,0.3)"
};
const _hoisted_31 = {
  key: 0,
  class: "list-box"
};
const _hoisted_32 = {
  key: 0,
  class: "item"
};
const _hoisted_33 = {
  class: "left"
};
const _hoisted_34 = {
  class: "container"
};
const _hoisted_35 = {
  class: "duration"
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  class: "center"
};
const _hoisted_38 = {
  class: "title"
};
const _hoisted_39 = ["href"];
const _hoisted_40 = {
  key: 0,
  class: "model"
};
const _hoisted_41 = {
  key: 1,
  class: "model"
};
const _hoisted_42 = {
  key: 2,
  class: "model"
};
const _hoisted_43 = {
  key: 3,
  class: "model"
};
const _hoisted_44 = {
  key: 0,
  class: "tags"
};
const _hoisted_45 = {
  class: "right"
};
const _hoisted_46 = {
  class: "tools grid grid-flow-row auto-rows-max"
};
const _hoisted_47 = ["onClick"];
const _hoisted_48 = {
  class: "btn btn-publish"
};
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
  key: 0,
  class: "iconfont icon-download"
};
const _hoisted_51 = ["onClick"];
const _hoisted_52 = ["data-clipboard-text"];
const _hoisted_53 = ["onClick"];
const _hoisted_54 = ["onClick"];
const _hoisted_55 = {
  key: 1,
  class: "task"
};
const _hoisted_56 = {
  class: "left"
};
const _hoisted_57 = {
  class: "title"
};
const _hoisted_58 = {
  key: 0
};
const _hoisted_59 = {
  key: 1
};
const _hoisted_60 = {
  class: "center"
};
const _hoisted_61 = {
  key: 0,
  class: "failed"
};
const _hoisted_62 = {
  class: "right"
};
const _hoisted_63 = {
  class: "pagination"
};
const _hoisted_64 = {
  key: 2,
  class: "music-player"
};
const _hoisted_65 = {
  class: "form"
};
const _hoisted_66 = {
  class: "form-item"
};
const _hoisted_67 = {
  class: "form-item"
};
import nodata from "@/assets/img/no-data.png";
import { nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import { Delete, InfoFilled } from "@element-plus/icons-vue";
import BlackSelect from "@/components/ui/BlackSelect.vue";
import BlackSwitch from "@/components/ui/BlackSwitch.vue";
import BlackInput from "@/components/ui/BlackInput.vue";
import MusicPlayer from "@/components/MusicPlayer.vue";
import { compact } from "lodash";
import { httpDownload, httpGet, httpPost } from "@/utils/http";
import { showMessageError, showMessageOK } from "@/utils/dialog";
import { checkSession, getClientId } from "@/store/cache";
import { ElMessage, ElMessageBox } from "element-plus";
import { formatTime, replaceImg } from "@/utils/libs";
import Clipboard from "clipboard";
import BlackDialog from "@/components/ui/BlackDialog.vue";
import Compressor from "compressorjs";
import Generating from "@/components/ui/Generating.vue";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'Suno',
  setup(__props) {
    const custom = ref(false);
    const models = ref([{
      label: "v3.0",
      value: "chirp-v3-0"
    }, {
      label: "v3.5",
      value: "chirp-v3-5"
    }, {
      label: "v4.0",
      value: "chirp-v4"
    }]);
    const tags = ref([{
      label: "女声",
      value: "female vocals"
    }, {
      label: "男声",
      value: "male vocals"
    }, {
      label: "流行",
      value: "pop"
    }, {
      label: "摇滚",
      value: "rock"
    }, {
      label: "硬摇滚",
      value: "hard rock"
    }, {
      label: "电音",
      value: "electronic"
    }, {
      label: "金属",
      value: "metal"
    }, {
      label: "重金属",
      value: "heavy metal"
    }, {
      label: "节拍",
      value: "beat"
    }, {
      label: "弱拍",
      value: "upbeat"
    }, {
      label: "合成器",
      value: "synth"
    }, {
      label: "吉他",
      value: "guitar"
    }, {
      label: "钢琴",
      value: "piano"
    }, {
      label: "小提琴",
      value: "violin"
    }, {
      label: "贝斯",
      value: "bass"
    }, {
      label: "嘻哈",
      value: "hip hop"
    }]);
    const data = ref({
      client_id: getClientId(),
      model: "chirp-v3-0",
      tags: "",
      lyrics: "",
      prompt: "",
      title: "",
      instrumental: false,
      ref_task_id: "",
      extend_secs: 0,
      ref_song_id: ""
    });
    const loading = ref(false);
    const noData = ref(true);
    const playList = ref([]);
    const playerRef = ref(null);
    const showPlayer = ref(false);
    const list = ref([]);
    const btnText = ref("开始创作");
    const refSong = ref(null);
    const showDialog = ref(false);
    const editData = ref({
      title: "",
      cover: "",
      id: 0
    });
    const promptPlaceholder = ref("请在这里输入你自己写的歌词...");
    const store = useSharedStore();
    const clipboard = ref(null);
    onMounted(() => {
      clipboard.value = new Clipboard(".copy-link");
      clipboard.value.on("success", () => {
        ElMessage.success("复制歌曲链接成功！");
      });
      clipboard.value.on("error", () => {
        ElMessage.error("复制失败！");
      });
      checkSession().then(() => {
        fetchData(1);
      }).catch(() => {});
      store.addMessageHandler("suno", data => {
        // 丢弃无关消息
        if (data.channel !== "suno" || data.clientId !== getClientId()) {
          return;
        }
        if (data.body === "FINISH" || data.body === "FAIL") {
          fetchData(1);
        }
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
      store.removeMessageHandler("suno");
    });
    const page = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const fetchData = _page => {
      if (_page) {
        page.value = _page;
      }
      loading.value = true;
      httpGet("/suno/list", {
        page: page.value,
        page_size: pageSize.value
      }).then(res => {
        total.value = res.data.total;
        const items = [];
        for (let v of res.data.items) {
          if (v.progress === 100) {
            v.major_model_version = v["raw_data"]["major_model_version"];
          }
          items.push(v);
        }
        loading.value = false;
        list.value = items;
        noData.value = list.value.length === 0;
      }).catch(e => {
        loading.value = false;
        noData.value = true;
        showMessageError("获取作品列表失败：" + e.message);
      });
    };

    // 创建新的歌曲
    const create = () => {
      data.value.type = custom.value ? 2 : 1;
      data.value.ref_task_id = refSong.value ? refSong.value.task_id : "";
      data.value.ref_song_id = refSong.value ? refSong.value.song_id : "";
      data.value.extend_secs = refSong.value ? refSong.value.extend_secs : 0;
      if (refSong.value) {
        if (data.value.extend_secs > refSong.value.duration) {
          return showMessageError("续写开始时间不能超过原歌曲长度");
        }
      } else if (custom.value) {
        if (data.value.lyrics === "") {
          return showMessageError("请输入歌词");
        }
        if (data.value.title === "") {
          return showMessageError("请输入歌曲标题");
        }
      } else {
        if (data.value.prompt === "") {
          return showMessageError("请输入歌曲描述");
        }
      }
      httpPost("/suno/create", data.value).then(() => {
        fetchData(1);
        showMessageOK("创建任务成功");
      }).catch(e => {
        showMessageError("创建任务失败：" + e.message);
      });
    };

    // 拼接歌曲
    const merge = item => {
      httpPost("/suno/create", {
        song_id: item.song_id,
        type: 3
      }).then(() => {
        fetchData(1);
        showMessageOK("创建任务成功");
      }).catch(e => {
        showMessageError("合并歌曲失败：" + e.message);
      });
    };

    // 下载歌曲
    const download = item => {
      const url = replaceImg(item.audio_url);
      const downloadURL = `${process.env.VUE_APP_API_HOST}/api/download?url=${url}`;
      // parse filename
      const urlObj = new URL(url);
      const fileName = urlObj.pathname.split("/").pop();
      item.downloading = true;
      httpDownload(downloadURL).then(response => {
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        item.downloading = false;
      }).catch(() => {
        showMessageError("下载失败");
        item.downloading = false;
      });
    };
    const uploadAudio = file => {
      const formData = new FormData();
      formData.append("file", file.file, file.name);
      // 执行上传操作
      httpPost("/upload", formData).then(res => {
        httpPost("/suno/create", {
          audio_url: res.data.url,
          title: res.data.name,
          type: 4
        }).then(() => {
          fetchData(1);
          showMessageOK("歌曲上传成功");
        }).catch(e => {
          showMessageError("歌曲上传失败：" + e.message);
        });
        removeRefSong();
        ElMessage.success({
          message: "上传成功",
          duration: 500
        });
      }).catch(e => {
        ElMessage.error("文件传失败:" + e.message);
      });
    };

    // 续写歌曲
    const extend = item => {
      refSong.value = item;
      refSong.value.extend_secs = item.duration;
      data.value.title = item.title;
      custom.value = true;
      btnText.value = "续写歌曲";
      promptPlaceholder.value = "输入额外的歌词，根据您之前的歌词来扩展歌曲...";
    };

    // 更细歌曲
    const update = item => {
      showDialog.value = true;
      editData.value.title = item.title;
      editData.value.cover = item.cover_url;
      editData.value.id = item.id;
    };
    const updateSong = () => {
      if (editData.value.title === "" || editData.value.cover === "") {
        return showMessageError("歌曲标题和封面不能为空");
      }
      httpPost("/suno/update", editData.value).then(() => {
        showMessageOK("更新歌曲成功");
        showDialog.value = false;
        fetchData();
      }).catch(e => {
        showMessageError("更新歌曲失败：" + e.message);
      });
    };
    watch(() => custom.value, newValue => {
      if (!newValue) {
        removeRefSong();
      }
    });
    const removeRefSong = () => {
      refSong.value = null;
      btnText.value = "开始创作";
      promptPlaceholder.value = "请在这里输入你自己写的歌词...";
    };
    const play = item => {
      playList.value = [item];
      showPlayer.value = true;
      nextTick(() => playerRef.value.play());
    };
    const selectTag = tag => {
      if (data.value.tags.length + tag.value.length >= 119) {
        return;
      }
      data.value.tags = compact([...data.value.tags.split(","), tag.value]).join(",");
    };
    const removeJob = item => {
      ElMessageBox.confirm("此操作将会删除任务相关文件，继续操作码?", "删除提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpGet("/suno/remove", {
          id: item.id
        }).then(() => {
          ElMessage.success("任务删除成功");
          fetchData();
        }).catch(e => {
          ElMessage.error("任务删除失败：" + e.message);
        });
      }).catch(() => {});
    };
    const publishJob = item => {
      httpGet("/suno/publish", {
        id: item.id,
        publish: item.publish
      }).then(() => {
        ElMessage.success("操作成功");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    const getShareURL = item => {
      return `${location.protocol}//${location.host}/song/${item.song_id}`;
    };
    const uploadCover = file => {
      // 压缩图片并上传
      new Compressor(file.file, {
        quality: 0.6,
        success(result) {
          const formData = new FormData();
          formData.append("file", result, result.name);
          // 执行上传操作
          httpPost("/upload", formData).then(res => {
            editData.value.cover = res.data.url;
            ElMessage.success({
              message: "上传成功",
              duration: 500
            });
          }).catch(e => {
            ElMessage.error("图片上传失败:" + e.message);
          });
        },
        error(err) {
          console.log(err.message);
        }
      });
    };
    const isGenerating = ref(false);
    const createLyric = () => {
      if (data.value.lyrics === "") {
        return showMessageError("请输入歌词描述");
      }
      isGenerating.value = true;
      httpPost("/prompt/lyric", {
        prompt: data.value.lyrics
      }).then(res => {
        const lines = res.data.split("\n");
        data.value.title = lines.shift().replace(/\*/g, "");
        lines.shift();
        data.value.lyrics = lines.join("\n");
        isGenerating.value = false;
      }).catch(e => {
        showMessageError("歌词生成失败：" + e.message);
        isGenerating.value = false;
      });
    };
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tooltip, {
        content: "定义模式",
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(BlackSwitch, {
          value: custom.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => custom.value = $event),
          size: "large"
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        content: "请上传6-60秒的原始音频，检测到人声的音频将仅设为私人音频。",
        placement: "bottom-end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          class: "avatar-uploader",
          "auto-upload": true,
          "show-file-list": false,
          "http-request": uploadAudio,
          accept: ".wav,.mp3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "upload-music",
            round: "",
            type: "primary"
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("i", {
              class: "iconfont icon-upload"
            }, null, -1), _createElementVNode("span", null, "上传音乐", -1)])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(BlackSelect, {
        value: data.value.model,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => data.value.model = $event),
        options: models.value,
        placeholder: "请选择模型",
        style: {
          "width": "100px"
        }
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, [_createVNode(BlackSwitch, {
        value: data.value.instrumental,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => data.value.instrumental = $event),
        size: "default"
      }, null, 8, ["value"])]), _cache[16] || (_cache[16] = _createElementVNode("span", {
        class: "text"
      }, "纯音乐", -1))]), custom.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [!data.value.instrumental ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[17] || (_cache[17] = _createElementVNode("span", {
        class: "text"
      }, "歌词", -1)), _createVNode(_component_el_popover, {
        placement: "right",
        width: 200,
        trigger: "hover",
        content: "自己写歌词或寻求 AI 的帮助。使用两节歌词（8 行）可获得最佳效果。"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
          _: 1
        })]),
        _: 1
      })]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(BlackInput, {
        value: data.value.lyrics,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => data.value.lyrics = $event),
        type: "textarea",
        rows: 10,
        placeholder: promptPlaceholder.value
      }, null, 8, ["value", "placeholder"]), _createElementVNode("button", {
        class: "btn btn-lyric",
        onClick: createLyric
      }, "生成歌词")])), [[_directive_loading, isGenerating.value]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[18] || (_cache[18] = _createElementVNode("span", {
        class: "text"
      }, "音乐风格", -1)), _createVNode(_component_el_popover, {
        placement: "right",
        width: 200,
        trigger: "hover",
        content: "描述您想要的音乐风格（例如“原声流行音乐”）。Sunos 模特无法识别艺术家的名字，但能够理解音乐流派和氛围。"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_13, [_createVNode(BlackInput, {
        value: data.value.tags,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => data.value.tags = $event),
        type: "textarea",
        maxlength: 120,
        rows: 3,
        placeholder: "请输入音乐风格，多个风格之间用英文逗号隔开..."
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, tag => {
        return _openBlock(), _createElementBlock("span", {
          class: "tag",
          onClick: $event => selectTag(tag),
          key: tag.value
        }, _toDisplayString(tag.label), 9, _hoisted_16);
      }), 128))])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[19] || (_cache[19] = _createElementVNode("span", {
        class: "text"
      }, "歌曲名称", -1)), _createVNode(_component_el_popover, {
        placement: "right",
        width: 200,
        trigger: "hover",
        content: "给你的歌曲起一个标题，以便于分享、发现和组织。"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_19, [_createVNode(BlackInput, {
        value: data.value.title,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => data.value.title = $event),
        type: "textarea",
        rows: 1,
        placeholder: "请输入歌曲名称..."
      }, null, 8, ["value"])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[20] || (_cache[20] = _createElementVNode("span", {
        class: "text"
      }, "歌曲描述", -1)), _createVNode(_component_el_popover, {
        placement: "right",
        width: 200,
        trigger: "hover",
        content: "描述您想要的音乐风格和主题（例如：关于假期的流行音乐）。请使用流派和氛围，而不是特定的艺术家和歌曲风格，AI无法识别。"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_22, [_createVNode(BlackInput, {
        value: data.value.prompt,
        "onUpdate:value": _cache[6] || (_cache[6] = $event => data.value.prompt = $event),
        type: "textarea",
        rows: 10,
        placeholder: "例如：一首关于爱情的摇滚歌曲..."
      }, null, 8, ["value"])])])), refSong.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_cache[21] || (_cache[21] = _createElementVNode("span", {
        class: "text"
      }, "续写", -1)), _createVNode(_component_el_popover, {
        placement: "right",
        width: 200,
        trigger: "hover",
        content: "输入额外的歌词，根据您之前的歌词来扩展歌曲。"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_image, {
        src: refSong.value.cover_url,
        fit: "cover"
      }, null, 8, ["src"]), _createElementVNode("span", _hoisted_27, _toDisplayString(refSong.value.title), 1), _createVNode(_component_el_button, {
        type: "info",
        onClick: removeRefSong,
        size: "small",
        icon: _unref(Delete),
        circle: ""
      }, null, 8, ["icon"])]), _createElementVNode("div", _hoisted_28, [_cache[22] || (_cache[22] = _createTextVNode("从 ")), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => refSong.value.extend_secs = $event),
        type: "text"
      }, null, 512), [[_vModelText, refSong.value.extend_secs]]), _cache[23] || (_cache[23] = _createTextVNode(" 秒开始续写"))])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: create,
        dark: false,
        round: ""
      }, {
        default: _withCtx(() => [_cache[24] || (_cache[24] = _createElementVNode("img", {
          src: "/images/create-new.svg",
          alt: ""
        }, null, -1)), _createElementVNode("span", null, _toDisplayString(btnText.value), 1)]),
        _: 1
      })])])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [!noData.value ? (_openBlock(), _createElementBlock("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id
        }, [item.progress === 100 ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createVNode(_component_el_image, {
          src: item.cover_url,
          fit: "cover"
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(formatTime)(item.duration)), 1), _createElementVNode("button", {
          class: "play",
          onClick: $event => play(item)
        }, _cache[25] || (_cache[25] = [_createElementVNode("img", {
          src: "/images/play.svg",
          alt: ""
        }, null, -1)]), 8, _hoisted_36)])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("a", {
          href: '/song/' + item.song_id,
          target: "_blank"
        }, _toDisplayString(item.title), 9, _hoisted_39), item.major_model_version ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(item.major_model_version), 1)) : _createCommentVNode("", true), item.type === 4 ? (_openBlock(), _createElementBlock("span", _hoisted_41, "用户上传")) : _createCommentVNode("", true), item.type === 3 ? (_openBlock(), _createElementBlock("span", _hoisted_42, _cache[26] || (_cache[26] = [_createElementVNode("i", {
          class: "iconfont icon-mp3"
        }, null, -1), _createTextVNode(" 完整歌曲 ")]))) : _createCommentVNode("", true), item.ref_song ? (_openBlock(), _createElementBlock("span", _hoisted_43, [_cache[27] || (_cache[27] = _createElementVNode("i", {
          class: "iconfont icon-link"
        }, null, -1)), _createTextVNode(" " + _toDisplayString(item.ref_song.title), 1)])) : _createCommentVNode("", true)]), item.tags ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(item.tags), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createVNode(_component_el_tooltip, {
          content: "以当前歌曲为素材继续创作",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("button", {
            class: "btn",
            onClick: $event => extend(item)
          }, "续写", 8, _hoisted_47)]),
          _: 2
        }, 1024), _createElementVNode("button", _hoisted_48, [_cache[28] || (_cache[28] = _createElementVNode("span", {
          class: "text"
        }, "发布", -1)), _createVNode(BlackSwitch, {
          value: item.publish,
          "onUpdate:value": $event => item.publish = $event,
          onChange: $event => publishJob(item),
          size: "small"
        }, null, 8, ["value", "onUpdate:value", "onChange"])]), _createVNode(_component_el_tooltip, {
          content: "下载歌曲",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("button", {
            class: "btn btn-icon",
            onClick: $event => download(item)
          }, [!item.downloading ? (_openBlock(), _createElementBlock("i", _hoisted_50)) : (_openBlock(), _createBlock(_component_el_image, {
            key: 1,
            src: "/images/loading.gif",
            class: "downloading",
            fit: "cover"
          }))], 8, _hoisted_49)]),
          _: 2
        }, 1024), item.ref_song ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          content: "获取完整歌曲",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("button", {
            class: "btn btn-icon",
            onClick: $event => merge(item)
          }, _cache[29] || (_cache[29] = [_createElementVNode("i", {
            class: "iconfont icon-concat"
          }, null, -1)]), 8, _hoisted_51)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), _createVNode(_component_el_tooltip, {
          content: "复制歌曲链接",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("button", {
            class: "btn btn-icon copy-link",
            "data-clipboard-text": getShareURL(item)
          }, _cache[30] || (_cache[30] = [_createElementVNode("i", {
            class: "iconfont icon-share1"
          }, null, -1)]), 8, _hoisted_52)]),
          _: 2
        }, 1024), _createVNode(_component_el_tooltip, {
          content: "编辑",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("button", {
            class: "btn btn-icon",
            onClick: $event => update(item)
          }, _cache[31] || (_cache[31] = [_createElementVNode("i", {
            class: "iconfont icon-edit"
          }, null, -1)]), 8, _hoisted_53)]),
          _: 2
        }, 1024), _createVNode(_component_el_tooltip, {
          content: "删除",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("button", {
            class: "btn btn-icon",
            onClick: $event => removeJob(item)
          }, _cache[32] || (_cache[32] = [_createElementVNode("i", {
            class: "iconfont icon-remove"
          }, null, -1)]), 8, _hoisted_54)]),
          _: 2
        }, 1024)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [item.title ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(item.title), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(item.prompt), 1))])]), _createElementVNode("div", _hoisted_60, [item.progress === 101 ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(item.err_msg), 1)) : (_openBlock(), _createBlock(Generating, {
          key: 1,
          message: "正在生成歌曲"
        }))]), _createElementVNode("div", _hoisted_62, [_createVNode(_component_el_button, {
          type: "info",
          onClick: $event => removeJob(item),
          circle: ""
        }, {
          default: _withCtx(() => _cache[33] || (_cache[33] = [_createElementVNode("i", {
            class: "iconfont icon-remove"
          }, null, -1)])),
          _: 2
        }, 1032, ["onClick"])])]))]);
      }), 128))])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 100,
        image: _unref(nodata),
        description: "没有任何作品，赶紧去创作吧！"
      }, null, 8, ["image"])), _createElementVNode("div", _hoisted_63, [total.value > pageSize.value ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        background: "",
        style: {
          "--el-pagination-button-bg-color": "rgba(86, 86, 95, 0.2)"
        },
        layout: "total,prev, pager, next",
        "hide-on-single-page": true,
        "current-page": page.value,
        "onUpdate:currentPage": _cache[8] || (_cache[8] = $event => page.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[9] || (_cache[9] = $event => pageSize.value = $event),
        onCurrentChange: _cache[10] || (_cache[10] = $event => fetchData(page.value)),
        total: total.value
      }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)]), showPlayer.value ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createVNode(MusicPlayer, {
        songs: playList.value,
        ref_key: "playerRef",
        ref: playerRef,
        "show-close": true,
        onClose: _cache[11] || (_cache[11] = $event => showPlayer.value = false)
      }, null, 8, ["songs"])])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]]), _createVNode(BlackDialog, {
        show: showDialog.value,
        "onUpdate:show": _cache[13] || (_cache[13] = $event => showDialog.value = $event),
        title: "修改歌曲",
        onCancal: _cache[14] || (_cache[14] = $event => showDialog.value = false),
        onConfirm: updateSong,
        width: 500 + 'px'
      }, {
        default: _withCtx(() => [_createElementVNode("form", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_cache[34] || (_cache[34] = _createElementVNode("div", {
          class: "label"
        }, "歌曲名称", -1)), _createVNode(_component_el_input, {
          modelValue: editData.value.title,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => editData.value.title = $event),
          type: "text"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_67, [_cache[35] || (_cache[35] = _createElementVNode("div", {
          class: "label"
        }, "封面图片", -1)), _createVNode(_component_el_upload, {
          class: "avatar-uploader",
          "auto-upload": true,
          "show-file-list": false,
          "http-request": uploadCover,
          accept: ".png,.jpg,.jpeg,.bmp"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_avatar, {
            src: editData.value.cover,
            shape: "square",
            size: 100
          }, null, 8, ["src"])]),
          _: 1
        })])])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};